import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  registerItemKeys,
  RequestTypes,
} from '@core/react-query/features/registers/registers/register/items/item'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { registerItemsKeys } from '@core/react-query/features/registers/registers/register/items'

export const useCreateRegisterItem = (
  options?: UseMutationOptions<
    any,
    RequestErrorType,
    RequestTypes['createRegisterItem']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerItemKeys.createRegisterItem,
    // We don't retry mutations since they're not idempotent
    // We can allow retries if we implement idempotency keys and idempotency checking on the back-end
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(registerItemsKeys.itemsByRegisterId._def)
    },
  })
}
